import React, { Component } from 'react'; // eslint-disable-line
import moment from 'moment-timezone';
import Clock from '../svg/Clock';

class TimeInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            hourValue: this.props.hour,
            minuteValue: this.props.minute,
            am: this.props.am,
            focus: 'not-focused',
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.hourValue !== prevState.hourValue
            || this.state.minuteValue !== prevState.minuteValue
            || this.state.am !== prevState.am) {
            this.props.timeinputchange(this.state, this.props.format24);
        }
        if (this.props.hour !== prevProps.hour) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ hourValue: this.props.hour });
        }
        if (this.props.minute !== prevProps.minute) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ minuteValue: this.props.minute });
        }
        if (this.props.am !== prevProps.am) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ am: this.props.am });
        }
        if (this.props.format24 !== prevProps.format24) {
            if (this.props.format24 === 'true') {
                if (this.state.am === 'am' && this.state.hourValue === '12') {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ hourValue: '00' });
                } else if (this.state.am === 'pm' && this.state.hourValue !== '12') {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        hourValue: (parseInt(prevState.hourValue, 10) + 12).toString(),
                    });
                }
            } else {
                if (this.state.hourValue === '00') {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ hourValue: '12' });
                }
                if (parseInt(this.state.hourValue, 10) > 11) {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ am: 'pm' });
                }
                if (parseInt(this.state.hourValue, 10) > 12) {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    let hour = (parseInt(this.state.hourValue, 10) - 12).toString();
                    if (hour.length < 2) {
                        hour = `0${hour}`;
                    }
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ hourValue: hour });
                }
            }
        }
    }

  onFocusFn = (e) => {
      this.setState({ focus: 'focused' });
      this.props.onFocus(e);
  }

  onKeyDownHourFn = (e) => {
      // Because HTML5 time inputs don't work in Safari, reinvent the wheel for the input box.
      // Replace this later with a simpler solution once Safari catches up with the world.
      let validFirstValues = ['0', '1'];
      if (this.props.format24 === 'true') {
          validFirstValues = ['0', '1', '2'];
      }
      const validSecondValues = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
      let validSecondValueSet1 = ['0', '1', '2'];
      let validSecondValueSet2 = [];
      if (this.props.format24 === 'true') {
          validSecondValueSet1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
          validSecondValueSet2 = ['0', '1', '2', '3'];
      }
      if (e.key === ':' || (e.key === 'ArrowRight' && this.state.hourValue.length === 2)) {
          e.preventDefault();
          const form = e.currentTarget.nextSibling.nextSibling; // colon is a sibling
          form.focus();
      }
      if (this.state.hourValue.length === 2
          && (this.state.hourValue.length - window.getSelection().toString().length === 2)) {
          if (validSecondValueSet1.indexOf(e.key) !== -1
              && ((parseInt(this.state.hourValue, 10) < 3 && this.props.format24 === 'true')
                  || (parseInt(this.state.hourValue, 10) < 2 && this.props.format24 === 'false'))) {
              const newHour = (parseInt(this.state.hourValue, 10) * 10
                  + parseInt(e.key, 10))
                  .toString();
              if ((parseInt(newHour, 10) < 24 && this.props.format24 === 'true')
                  || (parseInt(newHour, 10) < 13 && this.props.format24 === 'false')) {
                  this.setState({ hourValue: newHour });
              }
          } else if (e.key !== 'Backspace' && e.key !== ':'
              && e.key !== 'Tab' && e.key !== 'Shift' && e.key !== 'ArrowLeft'
              && e.key !== 'ArrowRight') {
              const form = e.currentTarget.nextSibling.nextSibling; // colon is a sibling
              form.focus();
          }
      }
      if (this.state.hourValue.length === 0
          && (this.state.hourValue.length - window.getSelection().toString().length === 0)) {
          if (validFirstValues.indexOf(e.key) === -1) {
              e.preventDefault();
              if (validSecondValues.indexOf(e.key) !== -1) {
                  this.setState({ hourValue: `0${e.key}` });
              }
          }
      }
      if (this.state.hourValue.length === 1
          && (this.state.hourValue.length - window.getSelection().toString().length === 1)) {
          if (e.key !== 'Backspace') {
              if (this.state.hourValue === '1' && validSecondValueSet1.indexOf(e.key) === -1) {
                  e.preventDefault();
              }
              if (this.state.hourValue === '2' && validSecondValueSet2.indexOf(e.key) === -1) {
                  e.preventDefault();
              }
          }
      }
  }

  onKeyDownMinuteFn = (e) => {
      // Because HTML5 time inputs don't work in Safari, reinvent the wheel for the input box.
      // Replace this later with a simpler solution once Safari catches up with the world.
      // Actually, IE 11 also doesn't support, so even once Safari catches up
      // we have to drop IE 11 support to drop this.
      const validFirstValues = ['0', '1', '2', '3', '4', '5'];
      const validSecondValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      if (e.target.selectionStart === 0 && e.key === 'ArrowLeft') {
          const form = e.currentTarget.previousSibling.previousSibling; // colon is a sibling
          form.focus();
          setTimeout(() => { return form.setSelectionRange(3, 3); }, 0);
          // Chrome still has a bug about setting focus.
          // A timeout of zero assures that this will fire after focus.
      }
      if (this.state.minuteValue.length === 0
      ) {
          if (e.key !== 'Tab' && e.key !== 'Shift' && validFirstValues.indexOf(e.key) === -1) {
              e.preventDefault();
              if (validSecondValues.indexOf(e.key) !== -1) {
                  this.setState({ minuteValue: `0${e.key}` });
              }
          }
      }
      if (this.state.minuteValue.length === 1) {
          if (e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== 'Shift'
              && validSecondValues.indexOf(e.key) === -1
              && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
              e.preventDefault();
          }
      }
      if (validSecondValues.indexOf(e.key) !== -1
          && parseInt(this.state.minuteValue, 10) < 6) {
          this.setState({
              // eslint-disable-next-line react/no-access-state-in-setstate
              minuteValue: (parseInt(this.state.minuteValue, 10) * 10
                  + parseInt(e.key, 10)).toString(),
          });
      }
  }

onKeyDownAmFn = (e) => {
    if (this.state.am) {
        if (e.key === 'p' || e.key === 'P') {
            this.setState({ am: false });
        }
    } else if (e.key === 'a' || e.key === 'A') {
        this.setState({ am: true });
    }
}

  onBlurFn = () => {
      this.setState({ focus: 'not-focused' });
      if (this.state.hourValue.length === 1) {
          // eslint-disable-next-line react/no-access-state-in-setstate
          this.setState({ hourValue: `0${this.state.hourValue}` });
      }
      if (this.state.minuteValue.length === 1) {
          // eslint-disable-next-line react/no-access-state-in-setstate
          this.setState({ minuteValue: `0${this.state.minuteValue}` });
      }
  }

  onChangeFn = (e) => {
      if (e.target.name === 'hour') {
          if ((this.props.format24 === 'true' && parseInt(e.target.value, 10) < 24)
              || (this.props.format24 === 'false' && parseInt(e.target.value, 10) < 13)) {
              this.setState({ hourValue: e.target.value });
          }
      }
      if (e.target.name === 'minute') {
          this.setState({ minuteValue: e.target.value });
      }
      if (e.target.name === 'am') {
          this.setState({ am: e.target.value });
      }
  }

  render() {
      return (
          <div className={`form-control react-time-input ${this.props.containerClass} ${this.state.focus} ${this.props.format24 === 'true' ? 'twenty-four' : ''}`}>
              <span className="clock"><Clock /></span>
              <input
                  type="text"
                  onKeyDown={this.onKeyDownHourFn}
                  name="hour"
                  value={this.state.hourValue}
                  onBlur={this.onBlurFn}
                  onChange={this.onChangeFn}
                  onFocus={this.onFocusFn}
                  maxLength={2}
                  placeholder="12"
                  className="messages-hour"
                  id="message-hour"
              />
              <span className="time-colon">:</span>
              <input
                  type="text"
                  onKeyDown={this.onKeyDownMinuteFn}
                  name="minute"
                  value={this.state.minuteValue}
                  onBlur={this.onBlurFn}
                  onChange={this.onChangeFn}
                  onFocus={this.onFocusFn}
                  maxLength={2}
                  placeholder="00"
                  className="messages-minute"
                  id="message-minute"
              />
              {this.props.format24 === 'false'
        && (
            <input
                type="text"
                onKeyDown={this.onKeyDownAmFn}
                name="am"
                value={this.state.am === 'am' || this.state.am === true ? 'am' : 'pm'}
                onBlur={this.onBlurFn}
                onChange={this.onChangeFn}
                onFocus={this.onFocusFn}
                maxLength={2}
                placeholder="am"
                className="messages-am"
                id="message-am"
            />
        )}
              <div className="timezone">{ moment.tz(moment.tz.guess()).format('z') }</div>
          </div>
      );
  }
}

export default TimeInput;
